import React from 'react'
import { isNotNilOrEmpty, noop } from '@solta/ramda-extra'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'
import { useField } from 'formik'
import DateFnsUtils from '@date-io/date-fns'
import { format, parse } from 'date-fns'

import { styled, s } from '@vega/styled/v2'
import { TextField } from '@vega/components'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'

const Root = styled.div(s(''))
const Container = styled.div(s('flex'), ({ labelPosition }) =>
  labelPosition === 'inline' ? s('flex-row items-center') : s('flex-column')
)
const Label = styled.label(
  s('tracking-wide text-base font-normal text-grey-700 mb-3', { lineHeight: 1.2 })
)

const datePickerTheme = createMuiTheme({
  overrides: {
    MuiPickersDay: {
      day: {
        '&:focus': s('bg-primary text-white'),
      },
      daySelected: {
        ...s('bg-primary text-white'),
        '&:hover': {
          backgroundColor: '#9E2AA4',
        },
      },
    },
  },
})

function DateField({
  disabled,
  isReadOnly,
  name,
  id,
  label,
  disablePast,
  labelPosition,
  inputFormat = 'dd/MM/yyyy',
  containerProps,
  pickerProps,
  inputStyle,
  inputContainerStyle,
  placeholder,
  labelProps,
  textFieldProps,
  testId,
  ...props
}) {
  const [{ value }, , { setValue: setFieldValue }] = useField({
    name,
    id,
  })

  function handleChange(date) {
    setFieldValue(format(date, inputFormat))
  }

  return (
    <Root {...containerProps}>
      <Container labelPosition={labelPosition}>
        <Label
          isVisible={isNotNilOrEmpty(label)}
          htmlFor={name || id}
          labelPosition={labelPosition}
          {...labelProps}
        >
          {label}
        </Label>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ThemeProvider theme={datePickerTheme}>
            <DatePicker
              {...props}
              label
              readOnly={isReadOnly}
              value={parse(value, inputFormat, new Date())}
              format={inputFormat}
              disablePast={disablePast}
              onAccept={handleChange}
              onChange={noop}
              reduceAnimations
              TextFieldComponent={(inputProps) => {
                return (
                  <TextField
                    {...inputProps}
                    name={name}
                    placeholder={placeholder}
                    aria-label={label}
                    isReadOnly={isReadOnly}
                    disabled={disabled}
                    testId={testId}
                    {...textFieldProps}
                  />
                )
              }}
            />
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </Container>
    </Root>
  )
}

export default DateField
